import { render, staticRenderFns } from "./technicalReform.vue?vue&type=template&id=5a3049b2&scoped=true"
import script from "./technicalReform.vue?vue&type=script&lang=js"
export * from "./technicalReform.vue?vue&type=script&lang=js"
import style0 from "./technicalReform.vue?vue&type=style&index=0&id=5a3049b2&scoped=true&lang=css"
import style1 from "./technicalReform.vue?vue&type=style&index=1&id=5a3049b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3049b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3049b2')) {
      api.createRecord('5a3049b2', component.options)
    } else {
      api.reload('5a3049b2', component.options)
    }
    module.hot.accept("./technicalReform.vue?vue&type=template&id=5a3049b2&scoped=true", function () {
      api.rerender('5a3049b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/facilityManage/technicalReform.vue"
export default component.exports